import { useMemo } from 'react';
import clsx from 'clsx';

//type
import type {
    SelectComponentProps,
    OptionType
} from '@/components/base/Select/SelectComponent/types';
import type { ButtonProps } from '@/components/base/Select/SelectComponent/SubComponents/SelectButton/Button';

//components
import { Button } from '@/components/base/Select/SelectComponent/SubComponents/SelectButton/Button';

type DefaultButtonProps<TOption, TSelected> = Omit<ButtonProps<TOption, TSelected>, 'children'> & {
    forcedDisplay?: SelectComponentProps<TOption, TSelected>['layoutOptions']['forcedDisplay'];
    isMultiple?: SelectComponentProps<TOption, TSelected>['layoutOptions']['forcedDisplay'];
};

export function DefaultButton<TOption extends OptionType, TSelected extends TOption | TOption[]>({
    error,
    disabled,
    selected,
    buttonVariant,
    size,
    forcedDisplay,
    isMultiple
}: Readonly<DefaultButtonProps<TOption, TSelected>>) {
    const buttonContent = useMemo(() => {
        if (isMultiple && Array.isArray(selected)) {
            let result = '';
            selected.forEach((label, index) => {
                if (index > 0) {
                    result += ', ';
                }
                result += label?.label;
            });
            return result;
        }
        return !Array.isArray(selected) && selected?.label;
    }, [isMultiple, selected]);

    return (
        <Button
            selected={selected}
            disabled={disabled}
            error={error}
            buttonVariant={buttonVariant}
            size={size}>
            <span
                data-testid="selectedContent"
                className={clsx('block truncate', {
                    'text-icoGray-400 dark:text-icoDarkMode-beton':
                        (!Array.isArray(selected) && selected?.value === null && !forcedDisplay) ||
                        (Array.isArray(selected) &&
                            selected?.filter((el) => !el?.value)?.length === 0 &&
                            !forcedDisplay) ||
                        disabled,
                    'text-icoBlack dark:text-white':
                        (!Array.isArray(selected) &&
                            selected?.label &&
                            selected?.value &&
                            !error &&
                            !disabled) ||
                        (Array.isArray(selected) &&
                            selected.filter((el) => el?.label && el?.value)?.length ===
                                selected.length &&
                            !error &&
                            !disabled),
                    'text-icoRed': error
                })}>
                {buttonContent}
            </span>
        </Button>
    );
}
